export default {
  custom_allergen: {
    placeholder: 'Benutzerdefinierte Option hinzufügen',
  },
  buttons: {
    add: 'Hinzufügen',
  },
};
